import { render, staticRenderFns } from "./RMAdministration.vue?vue&type=template&id=19a9d97a&"
import script from "./RMAdministration.vue?vue&type=script&lang=js&"
export * from "./RMAdministration.vue?vue&type=script&lang=js&"
import style0 from "./RMAdministration.vue?vue&type=style&index=0&id=19a9d97a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports